import styles from './styles.module.scss'
import classNames from 'classnames'
import { getColor, getSize } from '../../../assets/Js/modules/styles/styles.module'
import { createUseStyles } from 'react-jss'


//horizontalPosition=> 'left' || 'right' || 'auto'

export const ChatWindows = ({children, horizontalPosition='right', open=false, props}) => {
  const chatWidth = getSize({name:'width'})
  const chatMinHeight = getSize({name:'minHeight'})
  const chatBg = getColor({name:'bg'})
  const chatBoxShadow = getColor({name:'shadow'})



  //===>> CAHT POSITION
  const horizontalPositionStyle = {
    top: 0,
    bottom: 0
  }
  switch (horizontalPosition) {
    case 'left':
      horizontalPositionStyle.left = 0
      horizontalPositionStyle.right = 'initial'
      break
    case 'right':
      horizontalPositionStyle.right = 0
      horizontalPositionStyle.left = 'initial'
      break
  }

  const useStyles = createUseStyles({
    chatWindows: {
      width:0,
      opacity:0,
      transition: 'all .3s linear',

      minHeight: chatMinHeight,
      backgroundColor: chatBg,
      boxShadow: chatBoxShadow,
      ...horizontalPositionStyle
    },
    isOpen: {
      width:chatWidth,
      opacity: 1
    }
  })

  const classes = useStyles()

  return (
    <div className={classNames(styles.chatWindows, classes.chatWindows, {
      [classes.isOpen]:open
    })} {...props} data-name="chat-window">
      <div className={classNames(styles.chatWindows)} {...props}>
        {children}
      </div>
    </div>
  )
}
